/* =============================================
   ORONST ORBITAL — Hero Parallax Scroll Controller
   3-layer depth: stars (0.15x) → station (0.4x) → text (0.7x)
   Uses requestAnimationFrame for smooth 60fps
   ============================================= */

(function() {
  'use strict';

  // Parallax speed multipliers (fraction of scroll distance)
  var STAR_SPEED   = 0.15;  // slowest — deep background
  var STATION_SPEED = 0.4;  // mid — main subject
  var TEXT_SPEED    = 0.65;  // fastest — foreground text

  var section = document.querySelector('.section--slideshow');
  if (!section) return;

  // Respect user preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  var lastScrollY = 0;

  function updateParallax() {
    var rect = section.getBoundingClientRect();
    var sectionH = section.offsetHeight;
    var viewH = window.innerHeight;

    // Only compute when section is in viewport
    if (rect.bottom < 0 || rect.top > viewH) {
      ticking = false;
      return;
    }

    // Progress: 0 when section top hits viewport bottom, 1 when section bottom hits viewport top
    var progress = 1 - (rect.bottom / (viewH + sectionH));
    // Center around 0 so parallax is neutral at mid-point
    var offset = (progress - 0.5) * sectionH;

    // Apply CSS custom properties
    section.style.setProperty('--star-parallax-y', (offset * STAR_SPEED).toFixed(1) + 'px');
    section.style.setProperty('--parallax-y', (offset * STATION_SPEED).toFixed(1) + 'px');
    section.style.setProperty('--text-parallax-y', (offset * TEXT_SPEED).toFixed(1) + 'px');

    ticking = false;
  }

  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateParallax);
    }
  }

  // Use passive listener for scroll performance
  window.addEventListener('scroll', onScroll, { passive: true });
  // Initial position
  updateParallax();
})();
